import ActivationStatistics from "./../../models/general/ActivationStatistics";
import Place from "./Place";
import PlacesFilter from "./PlacesFilter";

export default class Places {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.listSort = [];
    this.activationStatistics = new ActivationStatistics();
    this.placesData = [];
    this.place = new Place();
    this.filterData = new PlacesFilter();
  }
  fillData(data) {
    if (data) {
      this.status = data.status;
      this.msg = data.msg;
      this.listSort = data.listSort || [];
      this.activationStatistics.fillData(data.activationStatistics);
      let filter = { ...this.filterData, ...data.pagination };
      this.filterData.fillData(filter);
      this.placesData = data.placesData || [];
    } else {
      this.setInitialValue();
    }
  }
}
